'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNewSignupUXWithoutSidebar = isNewSignupUXWithoutSidebar;
exports.default = isNewSignupUX;

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _isFunnel = require('./isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

var _frame = require('./frame');

var _getCustomSidebarOption = require('../components/sidebar/custom/getCustomSidebarOption');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isNewSignupUXWithoutSidebar() {
  return _isFunnel2.default.wordpress() && (0, _frame.isFramed)() || _isFunnel2.default.embeddedAcademy() || _isFunnel2.default.embeddedAllInOne();
}

function isNewSignupUX() {
  return (0, _getCustomSidebarOption.showSidebar)() || _AppConfigContainer2.default.get('hasSidebar') || isNewSignupUXWithoutSidebar();
}